module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_4.9cdd6494.png";